import { Metrics } from './SafeArea.types';

// amznmod_react for kepler, `initialWindowMetrics` is always null
// so assigning null directly, 
// and only calling getViewManagerConfig() for non-kepler platforms
export const initialWindowMetrics = null as Metrics | null;
/**
 * @deprecated
 */
export const initialWindowSafeAreaInsets = initialWindowMetrics?.insets;
